import React from 'react';

function TermsOfService() {
  return (
    <div className="container legal-page">
      <div className="card">
        <h1>Terms of Service</h1>
        <p>Last updated: November 19, 2025</p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using WhoIsYourSanta, you agree to be bound by these Terms of Service. If you do not
          agree, please discontinue use of the platform.
        </p>

        <h2>2. Eligibility</h2>
        <p>
          You must be at least 13 years old to use the service. By creating an account, you represent that you
          meet this requirement and that all information you provide is accurate.
        </p>

        <h2>3. Organizer Responsibilities</h2>
        <p>
          Organizers are responsible for the groups they create, including invitations, participant communication,
          and compliance with local laws. WhoIsYourSanta is not liable for disputes between organizers and members.
        </p>

        <h2>4. User Conduct</h2>
        <p>
          You agree not to misuse the service, interfere with other users, or attempt to access data without
          authorization. We reserve the right to suspend accounts that violate these guidelines.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          All branding, trademarks, and original content on the service remain the property of WhoIsYourSanta.
          You retain ownership of content you submit but grant us a license to host and display it as needed to
          operate the platform.
        </p>

        <h2>6. Termination</h2>
        <p>
          We may suspend or terminate access if you breach these terms or if necessary to protect the service and
          its users. You may stop using the platform at any time.
        </p>

        <h2>7. Disclaimer & Limitation of Liability</h2>
        <p>
          The service is provided “as is.” We do not guarantee uninterrupted availability and are not liable for
          any damages resulting from use of the platform.
        </p>

        <h2>8. Changes</h2>
        <p>
          We may update these terms from time to time. Continued use of the service after changes become effective
          constitutes acceptance of the revised terms.
        </p>

        <p>
          Questions? Contact <a href="mailto:support@whoisyoursanta.com">support@whoisyoursanta.com</a>.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;
